<template>
    <div class="px-2 px-sm-4">
        <v-row class="pt-1">
            <v-col cols="6">
                <span class="text-body-2 text-md-body-1 font-weight-bold text-uppercase">{{ sellerTitle }}</span>
            </v-col>
            <v-col cols="6" class="text-right">
                <span class="text-body-2 text-md-body-1 font-weight-bold">{{ $t('sum') }}: {{summaryPrice}} {{currency.cyrName.toLowerCase()}}</span>
            </v-col>
        </v-row>
        <template
            v-for="product in order.data"
        >
            <product-item
                :product="product"
                @order-change="orderChange"
            ></product-item>
            <v-divider class="py-1"></v-divider>
        </template>
    </div>
</template>

<script>
import ProductItem from "../ProductItem";
import OrderCalculator from "../../../../app-front/mixins/OrderCalculator";
import OrderDataProvider from "../../../../app-front/mixins/OrderDataProvider";
import numberFormat from "../../../../utils/numberFormat";


export default {
    name: "SellerItem",
    components: { ProductItem },
    mixins: [ OrderCalculator, OrderDataProvider ],
    props: [ 'order', 'date', 'paymentWay' ],
    computed: {
        currency() {
            return this.$store.getters.currencies.find(item => item.id === 1);
        },
        sellerTitle() {
            if (!this.order.seller) return '';
            return this.order.seller.companyName || `${this.order.seller.lastName} ${this.order.seller.firstName}`
        },
        summaryPrice() {
            return this.orderCalculatedPrice ? numberFormat(this.orderCalculatedPrice, 2, '.', ' ') : 0;
        },
        sellerOrder() {
            const inProcess = this.inProcessProducts || [];
            return inProcess.find(item => item.sellerID === this.order.seller.id);
        },
        orderProducts() {
            return this.sellerOrder ? this.sellerOrder.products : [];
        },
    },
    methods: {
        orderChange(data) {
            if (!data.price) {
                this.$store.commit('orderInProcessClearProduct', data.id);
            } else {
                const emitData = {
                    product: data,
                    policies: this.order.policies,
                    date: this.date,
                    paymentWay: this.paymentWay,
                    sellerID: this.order.seller.id
                };
                this.updateProductsInProcess(emitData);
            }
            this.calculatePrice();
        },
    },
    watch: {
        'sellerOrder.date'() {
            this.calculatePrice();
        },
        'sellerOrder.paymentWay'() {
            this.calculatePrice();
        }
    }
}
</script>

<style scoped>

</style>
